module.exports = __webpack_public_path__ + "media/images/pepsi_home/owner-icon-ab161ef3f0479790227042e04af1060f.svg";